import { Component, Input } from '@angular/core';
import { People } from '../../../models/people';
import { TranslatePipe } from '@ngx-translate/core';

// this component wraps the people status display
@Component({
  selector: 'app-people-status',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './people-status.component.html',
  styleUrl: './people-status.component.scss'
})
export class PeopleStatusComponent {

  @Input() person!: People;

}
